import { useEffect } from 'react';

const ConcordScript = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.src = 'https://api.concord.tech/site-v1/4da6acf6-94e0-492a-a7a2-8ae2fa5da0b3/site-client';
    script.type = 'text/javascript';
    script.async = true;

    // Add script to document
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return null; // This component doesn't render anything
};

export default ConcordScript; 